module.exports = __webpack_public_path__ + "img/Kloster_Orlad_1kl.a65b93cd.jpg";